"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.userTypesResponseExtractor = exports.userTypesStoreExtractor = exports.userTypeExtractor = void 0;
var userTypeExtractor = function (response) { return response.user_type; };
exports.userTypeExtractor = userTypeExtractor;
var userTypesStoreExtractor = function (response) { return response.user_types; };
exports.userTypesStoreExtractor = userTypesStoreExtractor;
var userTypesResponseExtractor = function (response) {
    return {
        count: response.count ? response.count : response.length,
        user_types: response.user_types ? response.user_types : response
    };
};
exports.userTypesResponseExtractor = userTypesResponseExtractor;
//# sourceMappingURL=UserType.consts.js.map